const items = [
  {
    header: 'bot.title',
  },
  {
    title: 'instagram.live-chat',
    route: 'owner:fb-chat',
    icon: 'MessageSquareIcon',
  },
  /* {
    title: 'bot.add_reply',
    route: 'owner:bot:flow',
    icon: 'MessageCircleIcon',
  }, */
  {
    title: 'bot.menu-templates',
    route: 'owner:bot:templates',
    icon: 'MessageCircleIcon',
  },
  {
    title: 'bot.subscribers',
    route: 'owner:bot:subscribers',
    icon: 'UserIcon',
  },
]
export default items.map(item => ({ ...item, shared: true }))
